
import { Modal } from "react-bootstrap";
import "./loading.scss";
import LoadingComponent from "../../components/loading/loading.component";

const LoadingModal = ({ show, onClose, message }) => {

    return (
        <Modal show={show} onHide={onClose} backdrop="static" centered>

            <Modal.Body className="body-wrapper">
                <LoadingComponent message={message} />
            </Modal.Body>

        </Modal>
    );
};

export default LoadingModal;
